const algoliasearch = require('algoliasearch')
const algoliasearchHelper = require('algoliasearch-helper')
const { isEmpty } = require('lodash')

const getFilterString = (originalFilters, facetFilters) => {
  if (isEmpty(facetFilters)) {
    return originalFilters
  }
  let alteredFilters = originalFilters
  if (facetFilters && originalFilters.includes('"isShowcased":"true"')) {
    alteredFilters = originalFilters.replace('"isShowcased":"true"', '"isShowcased":"true" OR "isShowcased":"false"')
  }
  const additionalFilters = Object.keys(facetFilters)
    .map(
      facet =>
        `(${facetFilters[facet]
          .map(filter => `"${facet}":"${filter.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`)
          .join(' OR ')})`,
    )
    .join(' AND ')
  return [alteredFilters, additionalFilters].filter(Boolean).join(' AND ')
}

exports.refine = ({
  oldState,
  filters,
  page = 1,
  index = process.env.GATSBY_ALGOLIA_REGION_INDEX,
  plpBanners,
  cancelPromise,
}) => {
  const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY)
  const hasUserFilter = !!Object.keys(filters ?? {}).length
  const ruleContexts = hasUserFilter
    ? oldState?.ruleContexts?.map(ruleContext => `${ruleContext}_weight`)
    : oldState?.ruleContexts
  const searchSettings = {
    query: oldState?.query,
    facets: oldState?.facets,
    hitsPerPage: (oldState?.hitsPerPage || 21) - plpBanners,
    ruleContexts,
    filters: getFilterString(oldState?.filters, filters),
    page: page - 1,
    distinct: hasUserFilter,
    ...(oldState?.attributesToRetrieve ? { attributesToRetrieve: oldState?.attributesToRetrieve } : {}),
  }

  const searchPromise = algoliasearchHelper(client, index, searchSettings).searchOnce()

  // If a cancelPromise is provided, race it against the searchPromise.
  if (cancelPromise) {
    return Promise.race([searchPromise, cancelPromise])
  }
  return searchPromise
}
